/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@ember/component';
import { tagName } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { debounce } from '@ember/runloop';
import { isNone } from '@ember/utils';
import isDestroyed from 'cio/utils/is-destroyed';
import { PowerCalendarDay, PowerCalendarPublicAPI, PowerCalendarWeek } from 'ember-power-calendar';
import { Dropdown as BasicDropdown } from 'ember-basic-dropdown/components/basic-dropdown';

const LATENCY = 250;

@tagName('')
export default class DatePickerDaysTooltipComponent extends Component {
  day!: PowerCalendarDay;
  calendar!: PowerCalendarPublicAPI;
  weeks!: PowerCalendarWeek[];
  showTooltip = true;

  @computed('showTooltip')
  get _showTooltip() {
    if (isNone(this.showTooltip)) {
      return true;
    }

    return this.showTooltip;
  }

  _toggleDropdown(dropdown: BasicDropdown, open = true) {
    if (isDestroyed(this)) {
      return;
    }

    if (open) {
      dropdown.actions.open();
    } else {
      dropdown.actions.close();
    }
  }

  @action
  delayedOpen(dropdown: BasicDropdown) {
    debounce(this, this._toggleDropdown, dropdown, true, LATENCY);
  }

  @action
  delayedClose(dropdown: BasicDropdown) {
    debounce(this, this._toggleDropdown, dropdown, false, LATENCY);
  }

  // Need to prevent click propagation on disabled inputs. Otherwise
  // ember-power-calendar will catch the click and select the date, even though
  // it's disabled.
  @action
  stopClickPropagation(e: MouseEvent) {
    e.stopPropagation();
  }
}
